import React from 'react';
import { motion } from 'framer-motion';
export function ClinicalGap() {
  return <section className="py-9 md:py-16 bg-clinical-deep text-white" data-id="element-35" data-mp="3d7zcny2oq58d">
      <div className="max-w-[820px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36" data-mp="3dad3fuqc0va4">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-37" data-mp="2zg2m3ygo03e3">
          <p className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-accent mb-3.5" data-id="element-38" data-mp="2girp6kii9m1t">
            Lo que nadie te enseña al recibirte
          </p>

          <h2 className="text-[1.35rem] sm:text-2xl md:text-[1.9rem] font-black leading-[1.15] text-white mb-4" data-id="element-39" data-mp="eqwh0evgjzoc">
            Tener el título no es lo mismo que tener criterio clínico.
          </h2>

          <p className="text-[15px] sm:text-lg leading-relaxed text-white/80 mb-3.5" data-id="element-40" data-mp="3rtz5acnkn5d0">
            Puedes conocer la teoría y aun así dudar cuando llega el momento de
            aplicarla. Qué valorar primero, qué procedimiento corresponde, qué
            información revisar o cómo razonar frente a una situación clínica.
          </p>

          <p className="text-[15px] sm:text-lg leading-relaxed text-white/70 border-l-2 border-clinical-accent pl-4" data-id="element-41" data-mp="gw287smc0ah">
            Atlas Clínico fue creado para ayudarte a reducir esa distancia entre
            estudiar enfermería y comenzar a ejercerla.
          </p>
        </motion.div>
      </div>
    </section>;
}